import { MarginBottom } from "shared/ui/marginBottom"
import { Container, RegisterWindow, Subtitle, Title } from "./styles"
import { LogoSvg } from "shared/ui/logoSvg"
import { Button, IconButton, Input } from "@atomaro/ui-kit"
import { PinInput } from "react-input-pin-code"
import { GRAYSCALE_91_COLOR, ORANGE_COLOR } from "shared/consts"
import { Controller } from "react-hook-form"
import { ArrowToLeftIcon, PassHide, PassShow } from "shared/ui/icons"
import {useRecover} from "widgets/recover/lib/useRecover.ts";

export const Recover = () => {

    const {
        control,
        realm,
        step,
        sendCodeText,
        sendCodeButtonType,
        sendCodeButtonDisabled,
        errors,
        pinValues,
        showPass,
        showConfirmPass,
        isLoading,
        isEmailBtnDisabled,
        emailPattern,
        register,
        onEmailComplete,
        onEmailSubmit,
        onBackClick,
        handleSubmit,
        reSendPin,
        setpinValues,
        onPassSubmit,
        setShowPass,
        setShowConfirmPass,
        changePass,
        changeConfirmPass,
        clearErrors,
        passValidate,
        setIsEmailBtnDisabled,
    } = useRecover();

    const passRules = {
        required: 'Введите пароль',
        minLength: {value: 6, message: 'Минимум 6 символов'},
        pattern: {
            value: /[^\s]+/g,
            message: 'Никаких пробелов'
        },
        validate: passValidate
    }

    return (
        <Container>
            {step === '1' &&
                <RegisterWindow onSubmit={handleSubmit(onEmailSubmit)}>
                    <IconButton
                        colorScheme="accent"
                        icon={<ArrowToLeftIcon />}
                        size="m"
                        variant="ghost"
                        className="back-button"
                        onClick={() => onBackClick(`/oauth/realms/${realm}/login/`)}
                    />
                    <MarginBottom $value={32}>
                        <LogoSvg
                            width={40}
                            height={40}
                        />
                    </MarginBottom>
                    <MarginBottom $value={32}>
                        <Title>
                            Введите e-mail
                        </Title>
                    </MarginBottom>
                    <MarginBottom $value={32} style={{width: '100%'}}>
                        <Input
                            {...register('login', {
                                required: true,
                                pattern: emailPattern.current,
                                validate: value => {
                                    if (!value) {
                                        setIsEmailBtnDisabled(true);
                                        return true;
                                    }
                                    if (!emailPattern.current.test(value)) {
                                        setIsEmailBtnDisabled(true);
                                        return 'Некорректный e-mail';
                                    }
                                },
                                onChange: event => {
                                    clearErrors('login')
                                    if (emailPattern.current.test(event.target.value)) {
                                        setIsEmailBtnDisabled(false);
                                    } else {
                                        setIsEmailBtnDisabled(true);
                                    }
                                },
                                onBlur: onEmailComplete,
                            })}
                            autoComplete="email"
                            size="l"
                            label="E-mail"
                            error={errors?.login ? (errors.login?.type === 'required' ? 'Введите e-mail' : (errors.login?.type === 'pattern' ? 'Некорректный e-mail' : (errors.login?.message || 'Некорректное значение поля'))) : undefined}
                        />
                    </MarginBottom>
                    <Button
                        disabled={isLoading||isEmailBtnDisabled}
                        label="Далее"
                        size="l"
                        style={{width: '100%'}}
                        onClick={handleSubmit(onEmailSubmit)}
                    />
                </RegisterWindow>
            }
            {step === '2' &&
                <RegisterWindow onSubmit={event => event.preventDefault()}>
                    <IconButton
                        colorScheme="accent"
                        icon={<ArrowToLeftIcon />}
                        size="m"
                        variant="ghost"
                        className="back-button"
                        onClick={() => onBackClick(`/oauth/realms/${realm}/recovery-password/1`)}
                    />
                    <MarginBottom $value={32}>
                        <LogoSvg
                            width={40}
                            height={40}
                        />
                    </MarginBottom>
                    <Title>
                        Введите код верификации
                    </Title>
                    <Subtitle>Код придет на вашу почту</Subtitle>
                    <MarginBottom $value={32}>
                        <PinInput
                            placeholder=""
                            values={pinValues}
                            size="lg"
                            borderColor={GRAYSCALE_91_COLOR}
                            focusBorderColor={ORANGE_COLOR}
                            validBorderColor={ORANGE_COLOR}
                            onChange={(_value, _index, values) => {
                                setpinValues(values)
                            }}
                        />
                    </MarginBottom>
                    <Button
                        onClick={reSendPin}
                        style={{width: '100%'}}
                        size="l"
                        label={sendCodeText}
                        variant={sendCodeButtonType}
                        disabled={sendCodeButtonDisabled||isLoading}
                    />
                </RegisterWindow>
            }
            {step === '3' &&
                <RegisterWindow onSubmit={handleSubmit(onPassSubmit)}>
                    <IconButton
                        colorScheme="accent"
                        icon={<ArrowToLeftIcon />}
                        size="m"
                        variant="ghost"
                        className="back-button"
                        onClick={() => onBackClick(`/oauth/realms/${realm}/recovery-password/2`)}
                    />
                    <MarginBottom $value={32}>
                        <LogoSvg
                            width={40}
                            height={40}
                        />
                    </MarginBottom>
                    <Title
                        $mb={32}
                    >
                        Придумайте новый пароль
                    </Title>

                    <Controller
                        name="password"
                        control={control}
                        rules={passRules}
                        render={({field}) => (
                            <MarginBottom $value={32} style={{width: '100%'}}>
                                <Input
                                    name={field.name}
                                    value={field.value}
                                    type={showPass ? 'text' : 'password'}
                                    autoComplete="new-password"
                                    size="l"
                                    label="Пароль"
                                    error={errors.password?.message}
                                    onChange={event => changePass(event, field)}
                                    iconSuffix={showPass ? <PassShow /> : <PassHide />}
                                    onClickIconSuffix={() => setShowPass(!showPass)}
                                    onFocus={() => clearErrors('password')}
                                />
                            </MarginBottom>
                        )}
                    />
                    <Controller
                        name="repeatPassword"
                        control={control}
                        rules={passRules}
                        render={({field}) => (
                            <MarginBottom $value={32} style={{width: '100%'}}>
                                <Input
                                    name={field.name}
                                    value={field.value}
                                    type={showConfirmPass ? 'text' : 'password'}
                                    size="l"
                                    label="Повторите пароль"
                                    error={errors.repeatPassword?.message}
                                    onChange={event => changeConfirmPass(event, field)}
                                    iconSuffix={showConfirmPass ? <PassShow /> : <PassHide />}
                                    onClickIconSuffix={() => setShowConfirmPass(!showConfirmPass)}
                                    onFocus={() => clearErrors('repeatPassword')}
                                />
                            </MarginBottom>
                        )}
                    />

                    <Button
                        type="submit"
                        style={{width: '100%'}}
                        size="l"
                        label="Сменить пароль"
                        disabled={isLoading}
                    />
                </RegisterWindow>
            }
        </Container>
    )
}
